import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { IconsModule } from '../../icons/icons.module';

import { FbfPickerModalComponent } from './fbf-picker-modal.component';

@NgModule({
	imports: [
		CommonModule,
		FormsModule,
		NgbModule,
		IconsModule
	],
	declarations: [
		FbfPickerModalComponent
	]
})
export class HelpModule {}
